// utils/optionMapper.js
export const mapToOptions = (data = [], valueKey, labelKey) =>
  data.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
    ...item
  }));
